export default milliseconds => {
    return function (result) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                resolve(result);
            }, milliseconds);
        });
    };
}